module.exports = __webpack_public_path__ + "static/media/mapa.a80e7fda.svg";